import React from 'react'
import { useSAML2 } from '../../sso/SAML2Provider'
import Button from '../Button/Button'

interface SAML2ButtonProps {
  id?: string
  'data-testid'?: string
  disabled?: boolean
  className?: string
}

const SAML2Button: React.FC<SAML2ButtonProps> = ({
  id,
  'data-testid': dataTestId,
  disabled = false,
  className = ''
}) => {
  const { initiateLogin, config } = useSAML2()

  return (
    <Button
      id={id}
      data-testid={dataTestId}
      className={`h-[86px] w-full diamond-btn font-bold flex justify-center items-center bg-dopage-primary ${className}`}
      onClick={initiateLogin}
      disabled={disabled}
      type='button'
    >
      <span className='text-black text-[26px]'>
        Continue with {config.displayName}
      </span>
    </Button>
  )
}

export { SAML2Button }





